
const DEFAULT_COLUMNS = [
  'count',
  'sampleStandardDeviation',
  'min',
  'firstQuantile',
  'median',
  'mean',
  'thirdQuantile',
  'max'];


export const getSelectedColumns = (columns, firstPass) => {
  const result = {};
  columns.forEach(name => {
    result[name] = { name, isSelected: true, isVisible: !!(firstPass && DEFAULT_COLUMNS.includes(name)), targetType: 'numerical' };
  });
  return result;
};


export const getSelectedColumnsCategory = columns => {
  const result = {};
  columns.forEach(name => {
    result[name] = { name, isSelected: true, isVisible: true, targetType: 'categorical' };
  });
  return result;
};

export const getSelectedStats = state => {
  const filters = state.selectedStats;
  const selectedStats = {};
  for (const stat in filters) {
    if (filters[stat].isVisible) {
      selectedStats[stat] = filters[stat];
    }
  }
  return selectedStats;
};

